import { SiteUrls } from '@tableau/shared-urls';

import { ServerUrls } from '../../app/ServerUrls';
import { ScheduleSubspaceName } from '../../app/state/SpaceInfo';
import { ScheduleActions } from '../../ts/ServerApi/types/ISchedule';

export function siteScheduleUrl(
  siteUrls: SiteUrls,
  scheduleId: string,
  scheduleAction: string, // ScheduleAction = 'Extract' | 'Flow' | 'Subscription'
): string {
  switch (scheduleAction) {
    case ScheduleActions.Extract:
      return siteUrls.scheduleExtractRefreshesUrl(scheduleId);
    case ScheduleActions.Flow:
      return siteUrls.scheduleFlowsUrl(scheduleId);
    case ScheduleActions.Subscription:
      return siteUrls.scheduleSubscriptionsUrl(scheduleId);
    case ScheduleActions.Data_Acceleration:
      return siteUrls.scheduleDetailsUrl(scheduleId);
  }
  return siteUrls.scheduleUrl(scheduleId);
}

export function serverScheduleUrl(
  serverUrls: ServerUrls,
  scheduleId: string,
  scheduleAction: string, // ScheduleAction = 'Extract' | 'Flow' | 'Subscription'
): string {
  switch (scheduleAction) {
    case ScheduleActions.Extract:
      return serverUrls.scheduleExtractRefreshesUrl(scheduleId);
    case ScheduleActions.Flow:
      return serverUrls.scheduleFlowsUrl(scheduleId);
    case ScheduleActions.Subscription:
      return serverUrls.scheduleSubscriptionsUrl(scheduleId);
    case ScheduleActions.Data_Acceleration:
      return serverUrls.scheduleDetailsUrl(scheduleId);
  }
  return serverUrls.scheduleUrl(scheduleId);
}

export function schedulePath(
  urls: ServerUrls | SiteUrls,
  scheduleId: string,
  scheduleAction: string, // ScheduleAction = 'Extract' | 'Flow' | 'Subscription'
): string {
  switch (scheduleAction) {
    case ScheduleActions.Extract:
      return urls.scheduleExtractRefreshesPath(scheduleId);
    case ScheduleActions.Flow:
      return urls.scheduleFlowsPath(scheduleId);
    case ScheduleActions.Subscription:
      return urls.scheduleSubscriptionsPath(scheduleId);
  }
  return urls.schedulePath(scheduleId);
}

export function scheduleSubspaceNameMatchesSchedule(subspaceName: ScheduleSubspaceName, scheduledAction: string): boolean {
  return (subspaceName === 'extractRefreshes' && scheduledAction === ScheduleActions.Extract) ||
    (subspaceName === 'subscriptions' && scheduledAction === ScheduleActions.Subscription) ||
    (subspaceName === 'flows' && scheduledAction === ScheduleActions.Flow);
}
